/**
 * @file ShopLiveChecksNotice.tsx
 * @description Плашка «Сайт работает без: …» на «Сводке» кабинета магазина
 * (phase19.16, SB125; партия SB120, этап 2 — uiux-sb120-stage2 §4; TD-407;
 * данные db-design-sb120-stage2 §6 `GET admin/site-view/live-issues`).
 *
 * На «Сводке» нет контекста конструктора, поэтому ошибки — из лёгкого
 * запроса `live-issues` (`useLiveSiteIssues`, свежесть 60 с). Видна только
 * при праве смотреть черновик вида сайта (`canViewSiteDraft`): остальным
 * плашки нет и запрос не уходит. Сайт не опубликован, ещё грузится или
 * запрос упал — ничего (без скелета, «Сводке» не мешаем).
 */

import { canViewSiteDraft } from "@chaiberi/shared";

import { LiveChecksNoticeView } from "./LiveChecksNotice";
import { useCurrentContext } from "../../auth/hooks";
import { useLiveSiteIssues } from "../../hooks/site-view/useLiveSiteIssues";
import { shopLevelErrors } from "../../lib/site-view/publish-acknowledge";

export function ShopLiveChecksNotice() {
  const ctx = useCurrentContext();
  const allowed = canViewSiteDraft(ctx?.role.permissions ?? []);
  // Кэш — по кабинету: другой магазин вкладки не видит чужую плашку.
  const entry = useLiveSiteIssues(allowed, ctx?.id ?? null);
  const data = entry?.data;
  if (!data?.published) return null;
  return <LiveChecksNoticeView errors={shopLevelErrors(data.errors)} />;
}
